import { Component, ViewEncapsulation } from "@angular/core";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

@Component({
  selector: "uni-scale-integration-doc",
  standalone: false,
  templateUrl: "./scale-integration-doc.component.html",
  encapsulation: ViewEncapsulation.None,
  host: { class: "flex flex-col flex-1 overflow-hidden" },
})
export class ScaleIntegrationDocComponent extends DomainBaseComponent {
  mdSrc = "/assets/docs/scale-integration.md";

  constructor(domainService: DomainService) {
    super(domainService);
    this.isPageReady = true;
  }
}
